import React, { useRef, useState } from 'react';

import TextField from '@material-ui/core/TextField'

const NativeDateInput = ({ value, hint, required, onChange }) => {
    const dateRef = useRef();
    const [highlight, setHighlight] = useState(required && !value);

    const handleChange = () => {
        setHighlight(required && !dateRef.current.value);

        if (dateRef.current.value) {
            onChange(dateRef.current.value);
        }
    }
    
    return (
        <TextField
            inputRef={dateRef}
            defaultValue={value}
            placeholder="dd/mm/yyyy"
            onChange={handleChange}
            type="date"
            helperText={hint}
            InputLabelProps={{
                shrink: true,
            }}
            error={highlight}
        />
    );
}

export default NativeDateInput;